import { Injectable } from '@angular/core';
import { UserLogin } from '@fsf/types';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  readonly #USER_KEY = 'user_data';

  setUser(userData: UserLogin) {
    localStorage.setItem(this.#USER_KEY, JSON.stringify(userData));
  }
  getUser(): UserLogin | null {
    const userData = localStorage.getItem(this.#USER_KEY);
    return userData ? JSON.parse(userData) : null;
  }
  clearUser() {
    localStorage.removeItem(this.#USER_KEY);
  }
}
